import { useMemo } from "react";
import { SelectAmongData } from "@vms/SelectAmong/SelectAmongContext";

export function useIsUserBrandsSelected(data: SelectAmongData) {
    return useMemo(
        () => (
            data.restaurants.length > 0
            || data.cStores.length > 0
            || data.supermarkets.length > 0
            || data.hotels.length > 0
            || data.brands.length > 0
            || data.segmentsAndOnSites.length > 0
            || data.deliveryServices.length > 0
        ),
        [data]
    );
}